import React from 'react';
import Typography from '@mui/material/Typography';
import { StyledBreadcrumbLink, StyledBreadcrumbLinkText, StyledBreadcrumbs } from './Breadcrumbs.styled';

export interface BreadcrumbItem {
  text: string;
  href: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  LinkComponent?: React.ElementType;
  dataTestID?: string;
}

export function Breadcrumbs({ items, LinkComponent = 'a', dataTestID = 'routeBreadcrumbs' }: BreadcrumbsProps) {
  return (
    <StyledBreadcrumbs aria-label="breadcrumb" data-testid={dataTestID}>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography key={`${item.href}-${item.text}`} color="text.primary" variant="body2">
              {item.text}
            </Typography>
          );
        }

        return (
          <StyledBreadcrumbLink
            key={`${item.href}-${item.text}`}
            component={LinkComponent}
            href={item.href}
            underline="none"
            color="inherit"
            variant="body2"
          >
            <StyledBreadcrumbLinkText variant="body2">{item.text}</StyledBreadcrumbLinkText>
          </StyledBreadcrumbLink>
        );
      })}
    </StyledBreadcrumbs>
  );
}

export default Breadcrumbs;
